import React, { useEffect, useState, useRef } from "react";
import "./index.less";
import PopupBottomModal from "../../../../components/popup-bottom-modal";
import {
  getParamsFromHash,
  navShow,
  callbackData
} from "../../../../utils/common";
import { getActivitySimpleInfo } from "../../api";
import StationList, {
  StationListRef
} from "../../../../components/station-list";
import ErrorPlaceholder from "../../../../components/placeholder/error";
import { useEventListener } from "ahooks";

const App = () => {
  const activityCode = getParamsFromHash("activityCode") || "";

  const isLoadingMore = useRef(false);
  const [loading, setLoading] = useState(true);
  const [showDetailedRule, setShowDetailedRule] = useState(false);
  const [activityDescInfo, setActivityDescInfo] = useState({
    description: "",
    detailRule: "",
    descriptionPic: "",
    filterCriteriaCodeList: []
  });
  const stationListRef = useRef<StationListRef>(null);
  const [isLoadingError, setIsLoadingError] = useState(false);

  // 默认查询半径100km，每次20条
  const queryParams = useRef({
    filterCriteriaCodeList: [],
    radius: 100000 // 单位米
  });

  useEffect(() => {
    document.title = "活动详情";
    navShow();
    // 若高德定位出错，则不展示具体站点距离，且直接使用总部定位请求接口
    getActivityInfo();
    callbackData({
      reflashActivityData: true
    });
  }, []);

  const getActivityInfo = async () => {
    try {
      const res: any = await getActivitySimpleInfo({
        activityCode
      });
      if (res.code !== 200) {
        return;
      }
      setActivityDescInfo({
        description: res.data?.description,
        detailRule: res.data?.detailRule,
        descriptionPic: res.data?.descriptionPic,
        filterCriteriaCodeList: res.data?.filterCriteriaCodeList || []
      });
      queryParams.current.filterCriteriaCodeList = res.data?.filterCriteriaCodeList || []
    } catch (error) {
      console.log("getActivityInfo error -->", error);
      setIsLoadingError(true);
    } finally {
      setLoading(false);
      isLoadingMore.current = false;
    }
  };

  const popDetailedRule = () => {
    setShowDetailedRule(true);
  };
  const ref = useRef<HTMLDivElement>(null);
  useEventListener(
    "scroll",
    e => {
      stationListRef.current?.onGoodsListScroll(e);
    },
    { target: ref }
  );

  if (loading) {
    return (
      <div className="loading">
        <div className="loading-icon"></div>
      </div>
    );
  }

  if (isLoadingError)
    return <ErrorPlaceholder message={"页面找不到"}></ErrorPlaceholder>;

  return (
    <div className="charge-marketing-detail" ref={ref}>
      <div
        className="description"
        style={{
          position: activityDescInfo?.descriptionPic ? "absolute" : "relative"
        }}
      >
        {activityDescInfo?.description}
      </div>
      {!!activityDescInfo?.descriptionPic && (
        <div className="description-image">
          <img
            alt=""
            src={activityDescInfo?.descriptionPic}
            className="image"
          />
        </div>
      )}
      {!!activityDescInfo?.detailRule && (
        <div className="detail-rule" onClick={popDetailedRule}>
          详细规则
        </div>
      )}

      <StationList
        autoFixedHeader={true}
        ref={stationListRef}
        requestParams={queryParams.current}
      />

      <PopupBottomModal
        visible={showDetailedRule}
        onClose={() => setShowDetailedRule(false)}
        title="详细规则"
      >
        <div className="rule-image">
          <img alt="" src={activityDescInfo?.detailRule} className="image" />
        </div>
      </PopupBottomModal>
    </div>
  );
};

export default App;
